import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// Import global styles for side effects
import './cards.css';
import './style.css';

ReactDOM.render(<App />, document.getElementById('app'));
